import React, { useState } from 'react';

function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    // Create mailto link as fallback
    const mailtoLink = `mailto:support@queerdatanetwork.com?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(
      `From: ${formData.name} (${formData.email})\n\n${formData.message}`
    )}`;

    // For now, we'll use a mailto link since we don't have a backend email service set up yet
    // In the future, this would send to an Azure Function or email service
    try {
      window.location.href = mailtoLink;
      setStatus({
        type: 'success',
        message: 'Opening your email client... If nothing happens, please email us directly at support@queerdatanetwork.com'
      });
      
      // Reset form after short delay
      setTimeout(() => {
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
      }, 2000);
    } catch (error) {
      setStatus({
        type: 'error',
        message: 'There was an error. Please email us directly at support@queerdatanetwork.com'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page">
      <div className="container">
        <div className="content-page">
          <h1>Contact Us</h1>
          
          <section className="content-section">
            <p className="lead">
              Have a question, suggestion, or concern? We'd love to hear from you! Fill out 
              the form below or email us directly at <strong>support@queerdatanetwork.com</strong>.
            </p>
          </section>

          <section className="content-section">
            <div className="contact-grid">
              <div className="contact-form-wrapper">
                <h2>Send us a message</h2>
                
                {status.message && (
                  <div className={`alert alert-${status.type}`}>
                    {status.message}
                  </div>
                )}

                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-group">
                    <label htmlFor="name">Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Your name or pseudonym"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="your.email@example.com"
                    />
                    <small className="form-help">We'll only use this to respond to your message</small>
                  </div>

                  <div className="form-group">
                    <label htmlFor="subject">Subject *</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      placeholder="What's this about?"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="8"
                      placeholder="Tell us what's on your mind..."
                    />
                  </div>

                  <button 
                    type="submit" 
                    className="btn btn-primary"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Sending...' : 'Send Message'}
                  </button>
                </form>
              </div>

              <div className="contact-info">
                <h2>Other ways to reach us</h2>
                
                <div className="contact-method">
                  <h3>General Inquiries</h3>
                  <p><strong>support@queerdatanetwork.com</strong></p>
                  <p>Questions, feedback, or general support</p>
                </div>

                <div className="contact-method">
                  <h3>Moderation & Safety</h3>
                  <p><strong>moderation@queerdatanetwork.com</strong></p>
                  <p>Report Code of Conduct violations or safety concerns</p>
                </div>

                <div className="contact-method">
                  <h3>Privacy & Data</h3>
                  <p><strong>privacy@queerdatanetwork.com</strong></p>
                  <p>Privacy questions, data requests, or account deletion</p>
                </div>

                <div className="contact-method">
                  <h3>Volunteer & Contribute</h3>
                  <p><strong>volunteer@queerdatanetwork.com</strong></p>
                  <p>Interested in helping build QDN</p>
                </div>

                <div className="contact-method">
                  <h3>Join the Community</h3>
                  <p><a href="https://discord.gg/Zg6m3gBx" target="_blank" rel="noopener noreferrer">Discord</a></p>
                  <p>Connect with other members in real-time</p>
                </div>

                <div className="response-time">
                  <h3>Response Time</h3>
                  <p>
                    We're a small volunteer team, so please allow 3-5 business days for a 
                    response. For urgent safety concerns, please indicate "URGENT" in the subject line.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
